import React from 'react'
import { ShieldAlert, UploadCloud } from 'lucide-react'
import { useFeatureFlags } from '@/flags'
import { Panel } from '@/components/editor/panels/panel-registry'
import { useCodeWidgetCheck } from '@/components/widgets/CodeWidget/analysis/use-code-widget-check'
import { usePublishCheck } from '@/components/lock-and-publish/use-publish-check'
import { LockAndPublishContent, PublishStatusDot } from '@/components/lock-and-publish/lock-and-publish-panel'
import { CodeWidgetDiagnosticsContent } from '@/components/CodeWidgetDiagnosticsPopup'

/**
 * Lock&Publish and Inspector Gadget as side-rail panels: the new-UX home of what the old
 * top bar shows as buttons. One scan feeds both, and the Lock&Publish rail icon carries
 * the status dot so the colour stays visible while the panel is closed.
 */
export function CodeWidgetCheckPanels() {
  const { inspectorGadget: inspectorGadgetIsEnabled } = useFeatureFlags()
  const codeWidgetCheck = useCodeWidgetCheck(true)
  const publishCheck = usePublishCheck(codeWidgetCheck)

  return (
    <>
      <Panel
        id="lock-and-publish"
        role="primary"
        title="Lock&Publish"
        railGroup="publish"
        icon={UploadCloud}
        sortOrder={70}
        defaultFloatingDimensions={{
          width: 620,
          height: 560,
        }}
        renderBadge={
          <PublishStatusDot check={publishCheck}
                            className="position-absolute ml-0 h-2 w-2"
                            style={{ top: "1px", right: "1px" }} />
        }
      >
        <LockAndPublishContent check={publishCheck} inspectorGadgetIsEnabled={inspectorGadgetIsEnabled} />
      </Panel>
      {inspectorGadgetIsEnabled && (
        <Panel
          id="inspector-gadget"
          role="primary"
          title="Inspector Gadget"
          railGroup="publish"
          icon={ShieldAlert}
          sortOrder={71}
          defaultFloatingDimensions={{
            width: 1100,
            height: 720,
          }}
        >
          <CodeWidgetDiagnosticsContent check={codeWidgetCheck} />
        </Panel>
      )}
    </>
  )
}
